import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";
/* import { CopyToClipboard } from "react-copy-to-clipboard"; */
import ReactJson from "react-json-view";
import classnames from "classnames";
import {
  Modal,
  ModalHeader,
  ModalBody,
  TabContent,
  Input,
  Label,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button,
  ButtonGroup,
  Pagination,
  PaginationItem,
  PaginationLink,
  Spinner,
} from "reactstrap";
import { getTranslate } from "react-localize-redux";
import * as d3 from "d3";
import dagreD3 from "dagre-d3";
import SplitterLayout from "react-splitter-layout";
import axios from "axios";
import Select from "react-select";
import "./Flows.css";
import { flowActions } from "../../../redux/actions";
import { flowConstants } from "../../../redux/constants";
import { formatSizeUnits } from "../../../utils/utils";
/* global $ */
class Flows extends React.Component {
  state = {
    graph: null,
    svgGroup: null,
    fullEventModal: false,
    eventJsonObj: {},
    fileParams: {
      PageNumber: 1,
      Size: 20,
      Status: "",
      Filename: "",
      EventId: "",
      Direction: "",
      FileType: "",
      ownid: "",
      batch: "",
      channel: "",
    },
    batchParams: {
      Status: "",
    },
    filesCounts: {
      ok: 0,
      warning: 0,
      error: 0,
      channel_statuses: [],
      file_types: [],
    },
    batchesCounts: {
      ok: 0,
      warning: 0,
      error: 0,
    },
    fileListLoading: false,
    fileListResult: [],
    filesTotalPages: 0,
    eventParams: {
      PageNumber: 1,
      Size: 20,
      Status: "",
      EventId: "",
    },
    eventsCounts: {
      ok: 0,
      warning: 0,
      error: 0,
      channel_statuses: [],
      file_types: [],
    },
    eventListLoading: false,
    eventListResult: [],
    eventsTotalPages: 0,
    docParams: {
      PageNumber: 1,
      Size: 20,
      Status: "",
      EventId: "",
      DocNr: "",
      DocId: "",
      batch: "",
      channel: "",
      isRelated: false,
    },
    docsCounts: {
      ok: 0,
      warning: 0,
      error: 0,
      channel_statuses: [],
      file_types: [],
    },
    docListLoading: false,
    docListResult: [],
    docsTotalPages: 0,
    Customer: "",
    Project: "",
    DocTitle: "",
    urlParams: {},
    fidfs: "",
  };

  toggle = (tab) => {
    this.props.dispatch(flowActions.toggleActiveTab(tab));
  };

  componentDidMount() {
    const { dispatch, flows } = this.props;
    let _searchQry = this.props.location.search;
    if (_searchQry) {
      var qs = require("qs");
      let queryObj = qs.parse(_searchQry.substr(1));
      if (queryObj["id"] && !flows.loading) {
        let params = {
          Id: queryObj["id"],
        };
        if (queryObj["docNr"]) {
          params["DocNr"] = queryObj["docNr"];
        }
        this.setState({
          urlParams: queryObj,
        });
        var me = this;
        this.getFullEvent(queryObj["id"]);
        dispatch(flowActions.getEventGroupTree(params)).then((payload) => {
          if (payload.type === flowConstants.GET_EVENT_GROUP_TREE_FAILURE) {
            me.clearGraph();
            return;
          }
          const { eventGroupTree } = this.props.flows;
          if (eventGroupTree && eventGroupTree.links && eventGroupTree.nodes) {
            this.buildGraph(eventGroupTree.links, eventGroupTree.nodes);
          }
        });
      }
    }
  }

  getFullEvent(eventId) {
    let params = {
        Id: eventId,
      },
      me = this;
    axios.get("Tracking/FullEvent", { params: params }).then((response) => {
      var json = response.data;
      if (json.Errors && json.Errors.length > 0) {
        // clear tree
        me.clearGraph();
        return;
      }
      if (json.Data) {
        const _header = json.Data.header;
        let _customer =
            _header.customer.name ||
            _header.customer.pid ||
            _header.customer.id,
          _project = _header.projectName || _header.project,
          _docTitle = "",
          _urlParams = me.state.urlParams;

        if (_header.level.id === "file") {
          _docTitle = json.Data.payload.file.name;
        } else if (
          _header.level.id === "doc" &&
          _urlParams["docNr"] &&
          _urlParams["docNr"].length > 0
        ) {
          _docTitle = _urlParams["docNr"];
        }
        const fidfs = `${_header.platform.id}::${_header.flowid}`;
        me.setState({
          Customer: _customer,
          Project: _project,
          DocTitle: _docTitle,
          fidfs,
        });
      }
    });
  }

  clearGraph() {
    var g = new dagreD3.graphlib.Graph()
      .setGraph({})
      .setDefaultEdgeLabel(function () {
        return {};
      });
    // Create the renderer
    var render = new dagreD3.render();

    // Set up an SVG group so that we can translate the final graph.
    var svgGroup = d3.select(ReactDOM.findDOMNode(this.refs.nodeTreeGroup));
    // Run the renderer. This is what draws the final graph.
    render(svgGroup, g);
  }
  buildGraph(links, nodes) {
    var g = new dagreD3.graphlib.Graph()
      .setGraph({})
      .setDefaultEdgeLabel(function () {
        return {};
      });

    var nodeArr = [],
      firstNode = null;

    var currentNode = this.props.flows.currentSelectedNode;
    var _nodeToSelect = null;
    // Here we"re setting nodeclass, which is used by our custom drawNodes function
    // below.
    nodes.forEach((node, indx) => {
      let event = node.event,
        _labelType = "",
        _style = "",
        _labelStyle = "",
        _label = "";

      if (this.props.user.flowHtml) {
        _labelType = "html";
        _style = this.getNodeHTMLStyle(event, false);
        _label = this.getNodeHTMLLabel(event);
        _labelStyle = this.getNodeHTMLLabelStyle(event, false);
      } else {
        _labelType = "text";
        _style = this.getNodeStyle(event, false);
        _label = this.getNodeLabel(event);
        _labelStyle = this.getNodeLabelStyle(event, false);
      }
      event.flagged = node.flagged;
      nodeArr[event.cid] = event;
      g.setNode(node.event.cid, {
        labelType: _labelType,
        rx: 5,
        ry: 5,
        event: event,
        label: (node.event.flagged ? "# " : "") + _label,
        originalLabelStyle: _labelStyle,
        labelStyle: _labelStyle,
        originalStyle: _style,
        style: _style,
        start: event.start
          ? moment
              .utc(event.start, moment.ISO_8601)
              .format("DD-MM-YYYY HH:mm:ss")
          : "n/a",
        end: event.end
          ? moment.utc(event.end, moment.ISO_8601).format("DD-MM-YYYY HH:mm:ss")
          : "n/a",
      });
    });
    g.nodes().forEach(function (v, indx) {
      var node = g.node(v);
      if (indx === 0) {
        firstNode = node;
      }
      if (
        currentNode &&
        node.event.id.platform === currentNode.event.id.platform &&
        node.event.id.service === currentNode.event.id.service
      ) {
        _nodeToSelect = node;
      }
      // Round the corners of the nodes
      node.rx = node.ry = 5;
    });
    links.forEach((link) => {
      g.setEdge(link.start, link.end);
    });
    // Create the renderer
    var render = new dagreD3.render();
    // Set up an SVG group so that we can translate the final graph.
    var svg = d3.select(ReactDOM.findDOMNode(this.refs.nodeTree));
    var svgGroup = d3.select(ReactDOM.findDOMNode(this.refs.nodeTreeGroup));
    var zoom = d3
      .zoom()
      .scaleExtent([0.2, 10])
      .on("zoom", function () {
        svgGroup.attr("transform", d3.event.transform);
      });
    svg.call(zoom);
    // Run the renderer. This is what draws the final graph.
    render(svgGroup, g);
    // Center the graph
    var initialScale = 0.65;
    var graphWidth = g.graph().width + 80;
    // Get SVG dimensions
    var width = parseInt(svg.style("width").replace(/px/, ""), 10);
    svg.call(
      zoom.transform,
      d3.zoomIdentity
        .translate((width - graphWidth * initialScale) / 2, 20)
        .scale(initialScale)
    );
    svg.attr("width", "100%");
    zoom.scaleTo(svg, initialScale);
    this.setState({
      graph: g,
      svgGroup: svgGroup,
    });
    if (_nodeToSelect) {
      this.selectNode(_nodeToSelect);
    } else if (firstNode) {
      this.selectNode(firstNode);
    }
  }
  selectNode(node) {
    var currentNode = this.props.flows.currentSelectedNode;
    if (currentNode !== node) {
      if (!!currentNode) {
        currentNode.style = currentNode.originalStyle;
        currentNode.labelStyle = currentNode.originalLabelStyle;
      }
      if (this.props.user.flowHtml) {
        node.style = this.getNodeHTMLStyle(node.event, true);
        node.labelStyle = this.getNodeHTMLLabelStyle(node.event, true);
      } else {
        node.style = this.getNodeStyle(node.event, true);
        node.labelStyle = this.getNodeLabelStyle(node.event, true);
      }
      this.props.dispatch(flowActions.setSelectedNode(node));
    } else {
      node = currentNode;
    }

    var render = new dagreD3.render();
    render(this.state.svgGroup, this.state.graph);
    var me = this,
      svgGroup = this.state.svgGroup,
      g = this.state.graph;
    svgGroup
      .selectAll("g.node")
      .attr("title", function (v) {
        return me.styleTooltip(v, g.node(v));
      })
      .each(function (v) {
        $(this).tipsy({ gravity: "w", opacity: 1, html: true });
      });

    svgGroup.selectAll("g.node").on("click", function (id) {
      var _node = g.node(id);
      $(".tipsy").remove();
      me.selectNode(_node);
    });
    this.setState({
      loading: true,
      fileParams: {
        PageNumber: 1,
        Size: 20,
        Status: "",
        Filename: "",
        EventId: "",
        Direction: "",
        FileType: "",
        ownid: "",
        batch: "",
        channel: "",
      },
      filesCounts: {
        ok: 0,
        warning: 0,
        error: 0,
        channel_statuses: [],
        file_types: [],
      },
      batchesCounts: {
        ok: 0,
        warning: 0,
        error: 0,
      },
      fileListLoading: false,
      fileListResult: [],
      filesTotalPages: 0,

      batchParams: {
        PageNumber: 1,
        Size: 20,
        Status: "",
      },

      eventParams: {
        PageNumber: 1,
        Size: 20,
        Status: "",
        EventId: "",
      },
      eventsCounts: {
        ok: 0,
        warning: 0,
        error: 0,
        channel_statuses: [],
        file_types: [],
      },
      eventListLoading: false,
      eventListResult: [],
      eventsTotalPages: 0,
      docParams: {
        PageNumber: 1,
        Size: 20,
        Status: "",
        EventId: "",
        DocNr: "",
        DocId: "",
        batch: "",
        channel: "",
        isRelated: false,
      },
      docsCounts: {
        ok: 0,
        warning: 0,
        error: 0,
        channel_statuses: [],
        file_types: [],
      },
      docListLoading: false,
      docListResult: [],
      docsTotalPages: 0,
    });
    this.loadAllStatusCounts(node.event);
  }

  loadAllStatusCounts(event) {
    let params = {
        cid: event.cid,
      },
      me = this;
    axios
      .get("Tracking/FlowViewAllStatusCount", { params: params })
      .then((response) => {
        var json = response.data;
        if (json.Data) {
          me.setState({
            loading: false,
            filesCounts: json.Data.files,
            docsCounts: json.Data.docs,
            eventsCounts: json.Data.events,
            batchesCounts: json.Data.batches,
          });
        }
      });
  }

  toggleFileStatus = (status) => {
    this.setState({
      fileParams: Object.assign(this.state.fileParams, { Status: status }),
    });
  };

  toggleBatchStatus = (status) => {
    this.setState({
      batchParams: Object.assign(this.state.batchParams, { Status: status }),
    });
  };

  toggleEventStatus = (status) => {
    this.setState({
      eventParams: Object.assign(this.state.eventParams, { Status: status }),
    });
  };

  toggleDocStatus = (status) => {
    this.setState({
      docParams: Object.assign(this.state.docParams, { Status: status }),
    });
  };

  onfilesFileNameChange = (e) => {
    this.setState({
      fileParams: Object.assign(this.state.fileParams, {
        Filename: e.target.value,
      }),
    });
  };

  onfilesEventIDChange = (e) => {
    this.setState({
      fileParams: Object.assign(this.state.fileParams, {
        EventId: e.target.value,
      }),
    });
  };

  onfilesOwnBatchIdChange = (e) => {
    this.setState({
      fileParams: Object.assign(this.state.fileParams, {
        ownid: e.target.value,
      }),
    });
  };

  onfilesParentBatchChange = (e) => {
    this.setState({
      fileParams: Object.assign(this.state.fileParams, {
        batch: e.target.value,
      }),
    });
  };

  onFilesChannelChange(e) {
    this.setState({
      fileParams: Object.assign(this.state.fileParams, {
        channel: e.target.value,
      }),
    });
  }

  onEventsEventIDChange(e) {
    this.setState({
      eventParams: Object.assign(this.state.eventParams, {
        EventId: e.target.value,
      }),
    });
  }

  onDocsEventIDChange(e) {
    this.setState({
      docParams: Object.assign(this.state.docParams, {
        EventId: e.target.value,
      }),
    });
  }

  onDocsDocNrChange(e) {
    this.setState({
      docParams: Object.assign(this.state.docParams, { DocNr: e.target.value }),
    });
  }

  onDocsDocIdChange(e) {
    this.setState({
      docParams: Object.assign(this.state.docParams, { DocId: e.target.value }),
    });
  }

  onDocsBatchIdChange(e) {
    this.setState({
      docParams: Object.assign(this.state.docParams, {
        batch: e.target.value,
      }),
    });
  }

  onDocsChannelChange(e) {
    this.setState({
      docParams: Object.assign(this.state.docParams, {
        channel: e.target.value,
      }),
    });
  }

  onOnlyFromThisFileCheckboxChange = (e) => {
    this.setState({
      docParams: Object.assign(this.state.docParams, {
        isRelated: !this.state.docParams.isRelated,
      }),
    });
  };

  handleChangeFileType = (selectedFileType) => {
    this.setState({
      fileParams: Object.assign(this.state.fileParams, {
        FileType: selectedFileType,
      }),
    });
  };

  handleChangeDirection(selectedDirection) {
    this.setState({
      fileParams: Object.assign(this.state.fileParams, {
        Direction: selectedDirection,
      }),
    });
  }

  onFileSearchClick(event) {
    event.preventDefault();
    if (this.props.flows.currentSelectedNode) {
      let currentEvent = this.props.flows.currentSelectedNode.event || {};
      let _fileParams = Object.assign(this.state.fileParams, {
        PageNumber: 1,
        cid: currentEvent.cid,
      });
      this.setState({
        fileParams: _fileParams,
      });
      this.getFilesDetails(_fileParams);
    }
  }

  getFilesDetails(fileParams) {
    let me = this;
    let _fileParams = Object.assign(fileParams);
    if (fileParams.FileType && fileParams.FileType.value) {
      _fileParams.FileType = fileParams.FileType.value;
    }
    if (fileParams.Direction && fileParams.Direction.value) {
      _fileParams.Direction = fileParams.Direction.value;
    }
    me.setState({
      fileListLoading: true,
    });
    axios
      .get("Tracking/FlowViewFilesDetails", { params: fileParams })
      .then((response) => {
        var json = response.data;
        if (json.Data) {
          if (
            fileParams.PageNumber === 1 ||
            json.TotalPages > fileParams.PageNumber
          ) {
            me.setState({
              fileListLoading: false,
              fileListResult: json.Data,
              filesTotalPages: json.TotalPages,
            });
          } else {
            me.setState({
              fileListLoading: false,
              fileListResult: json.Data,
            });
          }
        } else {
          me.setState({
            fileListLoading: false,
          });
        }
      });
  }

  onEventSearchClick(event) {
    event.preventDefault();
    if (this.props.flows.currentSelectedNode) {
      let currentEvent = this.props.flows.currentSelectedNode.event || {};
      let _eventParams = Object.assign(this.state.eventParams, {
        PageNumber: 1,
        cid: currentEvent.cid,
      });
      this.setState({
        eventParams: _eventParams,
      });
      this.getEventsDetails(_eventParams);
    }
  }

  getEventsDetails(eventParams) {
    let me = this;
    this.setState({
      eventListLoading: true,
    });
    axios
      .get("Tracking/FlowViewEventsDetails", { params: eventParams })
      .then((response) => {
        var json = response.data;
        if (json.Data) {
          if (
            eventParams.PageNumber === 1 ||
            json.TotalPages > eventParams.PageNumber
          ) {
            me.setState({
              eventListLoading: false,
              eventListResult: json.Data,
              eventsTotalPages: json.TotalPages,
            });
          } else {
            me.setState({
              eventListLoading: false,
              eventListResult: json.Data,
            });
          }
        } else {
          me.setState({
            eventListLoading: false,
          });
        }
      });
  }

  onDocSearchClick(event) {
    event.preventDefault();
    if (this.props.flows.currentSelectedNode) {
      let currentEvent = this.props.flows.currentSelectedNode.event || {};
      let _docParams = Object.assign(this.state.docParams, {
        PageNumber: 1,
        cid: currentEvent.cid,
      });
      this.setState({
        docParams: _docParams,
      });
      this.getDocsDetails(_docParams);
    }
  }

  getDocsDetails(docParams) {
    let me = this;
    me.setState({
      docListLoading: true,
    });
    axios
      .get("Tracking/FlowViewDocumentsDetails", { params: docParams })
      .then((response) => {
        var json = response.data;
        if (json.Data) {
          // dont update total page if pageNumber > total page
          if (
            docParams.PageNumber === 1 ||
            json.TotalPages > docParams.PageNumber
          ) {
            me.setState({
              docListLoading: false,
              docListResult: json.Data,
              docsTotalPages: json.TotalPages,
            });
          } else {
            me.setState({
              docListLoading: false,
              docListResult: json.Data,
            });
          }
        } else {
          me.setState({
            docListLoading: false,
          });
        }
      });
  }

  handleFileFirstClick(event) {
    event.preventDefault();
    let _fileParams = Object.assign(this.state.fileParams, { PageNumber: 1 });
    this.setState({
      fileParams: _fileParams,
    });
    this.getFilesDetails(_fileParams);
  }
  handleFilePageClick(event) {
    event.preventDefault();
    let _fileParams = Object.assign(this.state.fileParams, {
      PageNumber: Number(event.target.id),
    });
    this.setState({
      fileParams: _fileParams,
    });
    this.getFilesDetails(_fileParams);
  }

  handleEventFirstClick(event) {
    event.preventDefault();
    let _eventParams = Object.assign(this.state.eventParams, { PageNumber: 1 });
    this.setState({
      eventParams: _eventParams,
    });
    this.getEventsDetails(_eventParams);
  }
  handleEventPageClick(event) {
    event.preventDefault();
    let _eventParams = Object.assign(this.state.eventParams, {
      PageNumber: Number(event.target.id),
    });
    this.setState({
      eventParams: _eventParams,
    });
    this.getEventsDetails(_eventParams);
  }

  handleDocFirstClick(event) {
    event.preventDefault();
    let _docParams = Object.assign(this.state.docParams, { PageNumber: 1 });
    this.setState({
      docParams: _docParams,
    });
    this.getDocsDetails(_docParams);
  }
  handleDocPageClick = (event, PageNumber) => {
    event.preventDefault();
    let _docParams = Object.assign(this.state.docParams, {
      PageNumber,
    });
    this.setState({
      docParams: _docParams,
    });
    this.getDocsDetails(_docParams);
  };

  handleOpenFullEventClick = (e, eventId) => {
    let params = {
        Id: eventId,
      },
      me = this;
    axios.get("Tracking/FullEvent", { params: params }).then((response) => {
      var json = response.data;
      if (json.Data) {
        me.setState({
          eventJsonObj: json.Data,
          fullEventModal: true,
        });
      }
    });
  };

  handleGetDocsBucketClick = (e, docId) => {
    let params = {
        DobId: docId,
        Type: "doc",
      },
      me = this;
    axios.get("Tracking/GetDocsBucket", { params: params }).then((response) => {
      var json = response.data;
      if (json.Data) {
        me.setState({
          eventJsonObj: json.Data,
          fullEventModal: true,
        });
      }
    });
  };

  handleGetParkedClick = (e, docId) => {
    let params = {
        uniqueid: `d::X::${docId}`,
      },
      me = this;
    axios
      .get("Tracking/getparkeddocument", { params: params })
      .then((response) => {
        var json = response.data;
        if (json.Data) {
          me.setState({
            eventJsonObj: json.Data,
            fullEventModal: true,
          });
        }
      });
  };

  handleGetDocsBucketWithBatchClick = (e, batch) => {
    let params = {
        DobId: batch,
        Type: "batch",
      },
      me = this;
    axios.get("Tracking/GetDocsBucket", { params: params }).then((response) => {
      var json = response.data;
      if (json.Data) {
        me.setState({
          eventJsonObj: json.Data,
          fullEventModal: true,
        });
      }
    });
  };

  toggleFullEventModal = () => {
    this.setState({
      fullEventModal: !this.state.fullEventModal,
    });
  };

  onbackClick() {
    this.props.history.goBack();
  }

  handleRefreshTreeView = (e) => {
    const { dispatch, flows } = this.props;
    if (flows.params) {
      dispatch(flowActions.getEventGroupTree(flows.params)).then(() => {
        const { eventGroupTree } = this.props.flows;
        if (eventGroupTree && eventGroupTree.links && eventGroupTree.nodes) {
          this.buildGraph(eventGroupTree.links, eventGroupTree.nodes);
        }
      });
    }
  };

  showExternalUrlColumn = (items) => {
    if (items && items.length) {
      if (items.some((e) => !!e.externalLink)) {
        return true;
      }
    }
    return false;
  };

  getStatusColor = (event) => {
    const { platformNames } = this.props;
    var _status = "#70DB4D;";
    var platform = event.id.platform;
    let _platformObj = (platformNames || []).filter(
      (item) => item.platformId === platform
    )[0];
    if (_platformObj) {
      _status = _platformObj.colorHex + ";" || "#70DB4D;";
    }
    event.statusClass = "event-warning";
    event.portalStatus = "OK";
    event.statusClass = "event-ok";
    event.statuses.forEach((status, i) => {
      var value = status.toLowerCase();
      if (value === "error") {
        _status = "#FF644D;";
        event.portalStatus = "Error";
        event.statusClass = "event-error";
        return false;
      }
      if (value === "warning") {
        _status = "#FFFF58;";
        event.portalStatus = "Warning";
        event.statusClass = "event-warning";
      }
    });
    event.statusClass = "event-error";
    event.statusColor = _status;
    return _status;
  };

  getNodeHTMLLabelStyle = (event) => {
    var labelStyle = "text-shadow: none; font-size: 1.5em;";
    return labelStyle;
  };

  getNodeHTMLLabel = (event) => {
    var html = "",
      splitted = event.id.service.split(" "),
      title = splitted.join("");

    html += '<div className="step-container">';
    html +=
      '<div className="step-header" style="background-color: ' +
      event.statusColor +
      '">';
    html += '<strong className="step-header-title">' + title + "</strong>";
    html += "</div>";
    html += '<table className="table table-condensed node-table">';
    html += "<tbody>";
    html += "<tr>";
    if (event.flagged) {
      html +=
        '<td rowspan="2" style="vertical-align:middle; padding: 0px;"><span style="padding-left: 15px;" className="fa fa-briefcase fa-lg"></span></td>';
    }
    html +=
      '<td rowspan="2" style="vertical-align: middle;"><span style="font-size: 23px; padding-left: 15px; padding-right: 15px;"><strong>' +
      event.cnt +
      "</strong></span></td>";

    html +=
      '<td className="pull-right"><span style="padding-right: 5px;">' +
      event.portalStart +
      "</span></td>";
    html += "</tr>";
    html += "<tr>";
    html +=
      '<td className="pull-right"><span style="padding-right: 5px;">' +
      event.portalEnd +
      "</span></td>";

    html += "</tr>";
    html += "</tbody>";
    html += "</table>";
    html += "</div>";
    return html;
  };

  getNodeHTMLStyle = (event, selected) => {
    var style = "",
      fill = "fill: #FFFFFF";
    this.getStatusColor(event);
    if (selected) {
      fill = "fill: #8CD6FF";
    }

    style += fill;
    return style;
  };

  getNodeStyle = (event, selected) => {
    var style = "",
      fill = "fill: " + this.getStatusColor(event);
    var opacity = "opacity: 0.7;",
      strokeWidht = "stroke-width: 2px;";
    if (selected) {
      opacity = "opacity: 1;";
      strokeWidht = "stroke-width: 4px;";
    }
    style += fill;
    style += opacity;
    style += strokeWidht;
    return style;
  };

  getNodeLabelStyle = (event, selected) => {
    var labelStyle = "text-shadow: none; font-size: 1.5em;";
    if (selected) labelStyle += "font-weight: bold;";
    return labelStyle;
  };

  getNodeLabel = (event) => {
    var label = "";
    if (event.flagged) label += "# ";
    label +=
      event.id.platform + "::" + event.id.service + " (" + event.cnt + ")";
    return label;
  };

  // Simple function to style the tooltip for the given node.
  styleTooltip = (name, node) => {
    var durationText = "";
    if (node.event.start) {
      if (node.event.end) {
        durationText = moment
          .duration(moment(node.event.end).diff(moment(node.event.start)))
          .humanize();
      } else {
        durationText = moment(node.event.start).fromNow();
      }
    }
    return (
      `<table border="0" style="width:200px;font-size:12px;">
            <tr>
              <td><strong>${this.props.translate("StartDate")}:</strong></td>
              <td>` +
      node.start +
      `</td>
            </tr>
            <tr>
              <td><strong>${this.props.translate("EndDate")}:</strong></td>
              <td>` +
      node.end +
      `</td>
            </tr>
            <tr>
              <td><strong>${this.props.translate("Duration")}:</strong></td>
              <td>` +
      durationText +
      `</td>
            </tr>
            <tr>
              <td><strong>${this.props.translate("Status")}:</strong></td>
              <td>` +
      node.event.portalStatus +
      `</td>
            </tr>
            <tr>
              <td><strong>${this.props.translate("Instances")}:</strong></td>
              <td>` +
      node.event.cnt +
      `</td>
            </tr>
          </table>`
    );
  };

  handleOpenFiles = () => {
    const { urlParams, fidfs } = this.state;
    let qData = {
      fileId: urlParams && urlParams["id"],
    };
    if (fidfs) {
      qData["fidFs"] = fidfs;
    }
    var qs = require("qs");
    this.props.history.push("/files?" + qs.stringify(qData));
  };

  handleOpenDocument = () => {
    const { urlParams, fidfs } = this.state;
    let qData = {
      file_event_id: urlParams && urlParams["id"],
    };
    if (fidfs) {
      qData["fidfs"] = fidfs;
    }
    var qs = require("qs");
    this.props.history.push("/documents?" + qs.stringify(qData));
  };

  render() {
    const { eventGroupTree } = this.props.flows;
    let fileTypeOptions = (this.state.filesCounts.file_types || []).map(
      (item) => {
        return { value: item, label: item };
      }
    );

    const { event } = this.props.flows.currentSelectedNode || {};
    let eventId = (event || {}).id || {};
    let startEvent =
      event && event.start
        ? moment.utc(event.start, moment.ISO_8601).format("DD-MM-YYYY HH:mm:ss")
        : "";
    let endEvent =
      event && event.end
        ? moment.utc(event.end, moment.ISO_8601).format("DD-MM-YYYY HH:mm:ss")
        : "";

    let eventHost = "",
      eventMode = "";
    if (event) {
      eventHost = (event.hosts || []).join(", ");
      eventMode = (event.runs || []).join(", ");
    }

    let filePageNumber = this.state.fileParams.PageNumber;
    let prevFile = filePageNumber > 0 ? filePageNumber - 1 : 0;
    let lastFile = this.state.filesTotalPages;

    // Logic for displaying page numbers
    let pageNumbersFile = [];
    // get window of max 5
    let startFile = lastFile > 4 ? lastFile - 4 : 1;
    for (let i = startFile; i <= lastFile; i++) {
      pageNumbersFile.push(i);
    }

    let eventPageNumber = this.state.eventParams.PageNumber;
    let prevEvent = eventPageNumber > 0 ? eventPageNumber - 1 : 0;
    let lastEvent = this.state.eventsTotalPages;
    // Logic for displaying page numbers
    let pageNumbersEvent = [];
    // get window of max 5
    let startEv = lastEvent > 4 ? lastEvent - 4 : 1;
    for (let i = startEv; i <= lastEvent; i++) {
      pageNumbersEvent.push(i);
    }
    let docPageNumber = this.state.docParams.PageNumber;
    let prevDoc = docPageNumber > 0 ? docPageNumber - 1 : 0;
    let lastDoc = this.state.docsTotalPages;
    // Logic for displaying page numbers
    let pageNumbersDoc = [];
    // get window of max 5
    let startDoc = lastDoc > 4 ? lastDoc - 4 : 1;
    for (let i = startDoc; i <= lastDoc; i++) {
      pageNumbersDoc.push(i);
    }
    return (
      <div className="row" id="flow_main">
        <SplitterLayout
          percentage
          secondaryInitialSize={50}
          className="col-12 flow_view_D3"
        >
          <div
            id="flow_view_D3_pre"
            className="d-flex align-items-start flex-column d-inline-block h-100"
          >
            <div className="w-100">
              <div
                style={{ padding: "5px 0" }}
                className="d-flex flex-row justify-content-between"
              >
                <div id="flow_info">
                  <div style={{ marginBottom: "0.5em" }}>
                    <button
                      type="button"
                      onClick={this.onbackClick.bind(this)}
                      className="btn btn-secondary btn-sm"
                      style={{ marginLeft: "0.2rem", marginRight: "0.2rem" }}
                    >
                      <span
                        style={{ marginRight: "4px" }}
                        className="fa fa-arrow-left"
                        aria-hidden="true"
                      />
                      {this.props.translate("Back")}
                    </button>
                    <span>
                      <strong translate2="File">
                        {this.props.translate("File")}:{" "}
                      </strong>
                      <span className="flowCustom7">
                        <button
                          className="nav-link-btn"
                          onClick={() =>
                            this.handleOpenFiles(this.state.DocTitle)
                          }
                          data-toggle="tooltip"
                          data-placement="bottom"
                          data-container="body"
                          title={this.props.translate("Navigate to file")}
                        >
                          {this.state.DocTitle}
                        </button>
                      </span>
                    </span>
                  </div>
                  <div>
                    <strong translate2="Customer">
                      {this.props.translate("Customer")}:{" "}
                    </strong>
                    <span>{this.state.Customer} </span>
                    <strong translate2="Flow">
                      {this.props.translate("Flow")}:{" "}
                    </strong>
                    <span>{this.state.Project}</span>
                    <span className="event-header-separator">/</span>
                    {eventGroupTree && (
                      <>
                        <strong>{this.props.translate("FlowStarted")}: </strong>
                        <span className="hidden-sm-screen">
                          {eventGroupTree.FlowStartDate
                            ? moment
                                .utc(
                                  eventGroupTree.FlowStartDate,
                                  moment.ISO_8601
                                )
                                .format("DD-MM-YYYY HH:mm:ss")
                            : "n/a"}
                        </span>
                        <span className="ls-screen-hidden">
                          {eventGroupTree.FlowStartDate
                            ? moment
                                .utc(
                                  eventGroupTree.FlowStartDate,
                                  moment.ISO_8601
                                )
                                .format("DD-MM-YYYY HH:mm")
                            : "-"}
                        </span>
                      </>
                    )}
                  </div>
                  <div>
                    {eventGroupTree && eventGroupTree.DocNr && (
                      <div
                        style={{
                          paddingTop: "3px",
                        }}
                      >
                        <strong>
                          {this.props.translate("DocumentNumber")}:{" "}
                        </strong>
                        {eventGroupTree.DocNr}
                      </div>
                    )}
                  </div>
                </div>
                <div
                  id="flow_extra_info"
                  style={{
                    width: 95,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <button
                      className="btn smart-search-btn"
                      style={{ padding: 0, float: "right" }}
                      onClick={(e) => {
                        this.handleRefreshTreeView(e);
                      }}
                    >
                      <i className="fa fa-sync" style={{ padding: 0 }} />
                    </button>
                  </div>
                  <div
                    style={{ padding: 0, float: "right", textAlign: "right" }}
                  >
                    <strong>{this.props.translate("Documents")}: </strong>
                    <span className="flowCustom7">
                      <button
                        className="nav-link-btn"
                        onClick={() => this.handleOpenDocument()}
                        data-toggle="tooltip"
                        data-placement="bottom"
                        data-container="body"
                        title={this.props.translate("Navigate to documents")}
                      >
                        <span
                          data-action="open_documentbucketall"
                          className="fa fa-file-alt hidden-sm-screen"
                          style={{ fontSize: "1.5em" }}
                        />
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <svg
              className="svg-container"
              id="nodeTree"
              ref="nodeTree"
              width="100%"
              height="100%"
            >
              <g ref="nodeTreeGroup" />
            </svg>
          </div>
          <div id="flow_view_table" className="flex-column h-100">
            <Nav tabs justified>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.props.flows.activeTab === "1",
                  })}
                  onClick={() => {
                    this.toggle("1");
                  }}
                >
                  {this.props.translate("Files")}
                  &nbsp;
                  {this.state.loading ? (
                    <Spinner color="info" size="sm" />
                  ) : (
                    <span id="w_filesCount" className="w_filesCount">
                      <span className="badge">
                        {this.state.filesCounts.ok +
                          this.state.filesCounts.warning +
                          this.state.filesCounts.error}
                      </span>
                    </span>
                  )}{" "}
                  / {this.props.translate("Batches")}{" "}
                  {this.state.loading ? (
                    <Spinner color="info" size="sm" />
                  ) : (
                    <span id="w_batchesCount" className="w_batchesCount">
                      <span className="badge">
                        {this.state.batchesCounts.ok +
                          this.state.batchesCounts.warning +
                          this.state.batchesCounts.error}
                      </span>
                    </span>
                  )}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.props.flows.activeTab === "2",
                  })}
                  onClick={() => {
                    this.toggle("2");
                  }}
                >
                  {this.props.translate("Events")}
                  &nbsp;
                  {this.state.loading ? (
                    <Spinner color="info" size="sm" />
                  ) : (
                    <span id="w_eventsCount" className="w_eventsCount">
                      <span className="badge">
                        {this.state.eventsCounts.ok +
                          this.state.eventsCounts.warning +
                          this.state.eventsCounts.error}
                      </span>
                    </span>
                  )}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.props.flows.activeTab === "3",
                  })}
                  onClick={() => {
                    this.toggle("3");
                  }}
                >
                  {this.props.translate("Documents")}
                  &nbsp;
                  {this.state.loading ? (
                    <Spinner color="info" size="sm" />
                  ) : (
                    <span id="w_eventsCount" className="w_eventsCount">
                      <span className="badge">
                        {this.state.docsCounts.ok +
                          this.state.docsCounts.warning +
                          this.state.docsCounts.error}
                      </span>
                    </span>
                  )}
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent
              className="flows-tab-content"
              activeTab={this.props.flows.activeTab}
            >
              <TabPane className="h-100" tabId="1">
                <div className="d-flex" style={{ height: "inherit" }}>
                  <div className="d-flex flex-column w-100 flowCustom6">
                    <div className="">
                      <div className="d-flex flex-column flex-xl-row justify-content-center">
                        <div className="w-100">
                          <div className="w-100">
                            <ButtonGroup className="w-100">
                              <Button
                                active={this.state.fileParams.Status === ""}
                                onClick={() => {
                                  this.toggleFileStatus("");
                                }}
                                className="w-100"
                              >
                                {this.props.translate("All")}
                                <span
                                  id="w_filesCount_sub_all"
                                  className="w_filesCount_sub_all"
                                >
                                  (
                                  {this.state.filesCounts.ok +
                                    this.state.filesCounts.warning +
                                    this.state.filesCounts.error}
                                  )
                                </span>
                              </Button>
                              <Button
                                active={this.state.fileParams.Status === "ok"}
                                onClick={() => {
                                  this.toggleFileStatus("ok");
                                }}
                                className="w-100"
                              >
                                {this.props.translate("OK")}
                                <span
                                  id="w_filesCount_sub_ok"
                                  className="w_filesCount_sub_ok"
                                >
                                  ({this.state.filesCounts.ok})
                                </span>
                              </Button>
                              <Button
                                active={
                                  this.state.fileParams.Status === "warning"
                                    ? true
                                    : false
                                }
                                onClick={() => {
                                  this.toggleFileStatus("warning");
                                }}
                                className="w-100"
                              >
                                {this.props.translate("Warning")}
                                <span
                                  id="w_filesCount_sub_warning"
                                  className="w_filesCount_sub_warning"
                                >
                                  ({this.state.filesCounts.warning})
                                </span>
                              </Button>
                              <Button
                                active={
                                  this.state.fileParams.Status === "error"
                                    ? true
                                    : false
                                }
                                onClick={() => {
                                  this.toggleFileStatus("error");
                                }}
                                className="w-100"
                              >
                                {this.props.translate("Errors")}
                                <span
                                  id="w_filesCount_sub_error"
                                  className="w_filesCount_sub_error"
                                >
                                  ({this.state.filesCounts.error})
                                </span>
                              </Button>
                            </ButtonGroup>
                          </div>
                          <div
                            className="w-100 d-flex flex-column"
                            style={{ marginTop: ".5rem" }}
                          >
                            <div className="form-group flowCustom3">
                              <label
                                htmlFor="searchFileName"
                                className="sr-only"
                              >
                                <span translate2="File">
                                  {this.props.translate("File")}
                                </span>
                              </label>
                              <span className="event-search-control w-100">
                                <Input
                                  type="text"
                                  value={this.state.fileParams.Filename}
                                  onChange={this.onfilesFileNameChange.bind(
                                    this
                                  )}
                                  id="searchFileName"
                                  name="Filename"
                                  placeholder={`${this.props.translate(
                                    "FileName"
                                  )} (Use * to do 'starts with' search)`}
                                />
                              </span>
                            </div>
                            <div className="form-group flowCustom3">
                              <label
                                htmlFor="searchEventID"
                                className="sr-only"
                              >
                                <span translate2="File">
                                  {this.props.translate("EventID")}
                                </span>
                              </label>
                              <span className="event-search-control w-100">
                                <Input
                                  type="text"
                                  value={this.state.fileParams.EventId}
                                  onChange={this.onfilesEventIDChange}
                                  id="searchEventID"
                                  name="EventId"
                                  placeholder={this.props.translate("EventID")}
                                />
                              </span>
                            </div>
                            <div className="form-group flowCustom3">
                              <label
                                htmlFor="searchOwnBatchId"
                                className="sr-only"
                              >
                                <span translate2="File">
                                  {this.props.translate("OwnBatchId")}
                                </span>
                              </label>
                              <span className="event-search-control w-100">
                                <Input
                                  type="text"
                                  value={this.state.fileParams.ownid}
                                  onChange={this.onfilesOwnBatchIdChange}
                                  id="searchOwnBatchId"
                                  name="OwnBatchId"
                                  placeholder={`${this.props.translate(
                                    "OwnBatchId"
                                  )} (Use * to do 'starts with' search)`}
                                />
                              </span>
                            </div>
                            <div className="form-group flowCustom3">
                              <label
                                htmlFor="searchParentBatch"
                                className="sr-only"
                              >
                                <span translate2="File">
                                  {this.props.translate("ParentBatch")}
                                </span>
                              </label>
                              <span className="event-search-control w-100">
                                <Input
                                  type="text"
                                  value={this.state.fileParams.batch}
                                  onChange={this.onfilesParentBatchChange}
                                  id="searchParentBatch"
                                  name="ParentBatch"
                                  placeholder={`${this.props.translate(
                                    "ParentBatch"
                                  )} (Use * to do 'starts with' search)`}
                                />
                              </span>
                            </div>
                            <div
                              className="form-group flowCustom3"
                              style={{ marginBottom: "0.5em" }}
                            >
                              <label
                                htmlFor="searchFileName"
                                className="sr-only"
                              >
                                <span>{this.props.translate("Channel")}</span>
                              </label>
                              <span className="event-search-control w-100">
                                <Input
                                  type="text"
                                  value={this.state.fileParams.channel}
                                  onChange={this.onFilesChannelChange.bind(
                                    this
                                  )}
                                  name="Channel"
                                  placeholder={`${this.props.translate(
                                    "Channel"
                                  )} (Use * to do 'starts with' search)`}
                                />
                              </span>
                            </div>
                            <div className="form-group flowCustom3">
                              <label
                                htmlFor="fileTypeComboBox"
                                className="sr-only"
                              >
                                <span translate2="FileType">
                                  {this.props.translate("FileType")}
                                </span>
                              </label>
                              <span className="w-100">
                                <Select
                                  name="fileType_input"
                                  value={this.state.fileParams.FileType}
                                  onChange={this.handleChangeFileType}
                                  placeholder={this.props.translate(
                                    "Select file type..."
                                  )}
                                  options={fileTypeOptions}
                                />
                              </span>
                            </div>
                            <div className="form-group flowCustom3">
                              <label
                                htmlFor="searchDirection"
                                className="sr-only"
                              >
                                <span translate2="Direction">
                                  {this.props.translate("Direction")}
                                </span>
                              </label>
                              <span className="event-search-control w-100">
                                <Select
                                  name="direction_input"
                                  value={this.state.fileParams.Direction}
                                  onChange={this.handleChangeDirection.bind(
                                    this
                                  )}
                                  options={[
                                    { value: "1", label: "Input" },
                                    { value: "2", label: "Output" },
                                  ]}
                                  placeholder={this.props.translate(
                                    "Select direction..."
                                  )}
                                  data-placeholder={this.props.translate(
                                    "Direction"
                                  )}
                                />
                              </span>
                            </div>
                          </div>
                          <div className="flowCustom4">
                            <div className="btn-group eventSearchSubmit col-12">
                              <button
                                id="eventSearchSubmit"
                                onClick={this.onFileSearchClick.bind(this)}
                                type="submit"
                                data-type="files"
                                data-loading-text={
                                  this.props.translate("Loading") + "..."
                                }
                                className="btn btn-secondary btn-sm w_flow_subsearch"
                                style={{
                                  margin: "0.2em 0 1.2em 0em",
                                  backgroundColor: "rgb(230, 230, 230)",
                                }}
                              >
                                <span className="fa fa-search" />
                                <span style={{ marginLeft: "5px" }}>
                                  {this.props.translate("Search")}
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-100 h-100 border rounded flowCustom5">
                      <div className="table w_subsearch_res_body">
                        <div className="tr th" style={{ padding: "0.5em 0 0" }}>
                          <div className="td" style={{ flexGrow: "3" }}>
                            {this.props.translate("FileName")}
                          </div>
                          <div className="td" style={{ flexGrow: "2" }}>
                            {this.props.translate("ID")}
                          </div>
                          <div className="td" style={{ flexGrow: "1" }}>
                            {this.props.translate("Channel")}
                          </div>
                          <div className="td" style={{ flexGrow: "1" }}>
                            {this.props.translate("Direction")}
                          </div>
                          <div className="td" style={{ flexGrow: "1" }}>
                            {this.props.translate("Status")}
                          </div>
                          {this.showExternalUrlColumn(
                            this.state.fileListResult
                          ) && (
                            <div className="td" style={{ flexGrow: "0.5" }}>
                              URL
                            </div>
                          )}
                          <div className="td" style={{ flexGrow: "0.5" }}>
                            JSON
                          </div>
                          <div className="td" style={{ flexGrow: "0.5" }}>
                            DOB
                          </div>
                          <div className="td" style={{ flexGrow: "0.5" }}>
                            {this.props.translate("Batch")}
                          </div>
                        </div>
                        {this.state.fileListLoading ? (
                          <div className="tr">
                            <div
                              className="td justify-content-center"
                              style={{ flexGrow: "2" }}
                            >
                              <Spinner color="info" size="sm" />
                            </div>
                          </div>
                        ) : (
                          <>
                            {this.state.fileListResult &&
                              this.state.fileListResult.length > 0 &&
                              this.state.fileListResult.map((row, i) => {
                                return (
                                  <div key={i} className="tr">
                                    <div
                                      className="td"
                                      style={{ flexGrow: "3" }}
                                    >
                                      <div
                                        className="w_subsearch_res_text"
                                        style={{ display: "flex" }}
                                      >
                                        {/* <CopyToClipboard text={row.fname}>
                                          <button
                                            type="button"
                                            className="btn btn-default btn-xs btn-copy js-copy"
                                            style={{
                                              padding: "1px 2px",
                                              lineHeight: "0.8",
                                            }}
                                            data-container="body"
                                            title={this.props.translate(
                                              "Copy to clipboard"
                                            )}
                                          >
                                            <svg
                                              className="icon"
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                            >
                                              <path d="M17,9H7V7H17M17,13H7V11H17M14,17H7V15H14M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z" />
                                            </svg>
                                          </button>
                                        </CopyToClipboard> */}
                                        <div
                                          style={{
                                            marginLeft: "4px",
                                            whiteSpace: "initial",
                                          }}
                                        >
                                          {`(${formatSizeUnits(row.size)}) ${
                                            row.fname
                                          }`}
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="td"
                                      style={{ flexGrow: "2" }}
                                    >
                                      <div
                                        className="w_subsearch_res_text"
                                        style={{ whiteSpace: "initial" }}
                                      >
                                        {row.ownId}
                                      </div>
                                    </div>
                                    <div
                                      className="td"
                                      style={{ flexGrow: "1" }}
                                    >
                                      <div
                                        className="w_subsearch_res_text"
                                        data-container="body"
                                      >
                                        {row.ch}
                                      </div>
                                    </div>
                                    <div
                                      className="td"
                                      style={{ flexGrow: "1" }}
                                    >
                                      <div
                                        className="w_subsearch_res_text"
                                        data-container="body"
                                      >
                                        {row.dir}
                                      </div>
                                    </div>
                                    <div
                                      className="td"
                                      style={{ flexGrow: "1" }}
                                    >
                                      <div
                                        className="w_subsearch_res_text"
                                        data-container="body"
                                      >
                                        {row.link && row.link.length > 0 ? (
                                          <a
                                            href={row.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            <b>{row.st}</b>
                                          </a>
                                        ) : (
                                          row.st
                                        )}
                                      </div>
                                    </div>
                                    {this.showExternalUrlColumn(
                                      this.state.fileListResult
                                    ) && (
                                      <div
                                        className="td"
                                        style={{ flexGrow: "0.5" }}
                                      >
                                        <div
                                          className="w_subsearch_res_text"
                                          role="button"
                                          data-container="body"
                                        >
                                          {row.externalLink &&
                                            row.externalLink.link && (
                                              <button
                                                onClick={(e) => {
                                                  window.open(
                                                    row.externalLink.link,
                                                    "_blank"
                                                  );
                                                }}
                                                type="button"
                                                style={{ padding: "1px 6px" }}
                                                className="btn btn-default btn-xs w_p_action_sub"
                                                title={
                                                  row.externalLink.description
                                                }
                                              >
                                                <span
                                                  className="fa fa-external-link-alt"
                                                  aria-hidden="true"
                                                />
                                              </button>
                                            )}
                                        </div>
                                      </div>
                                    )}
                                    <div
                                      className="td"
                                      style={{ flexGrow: "0.5" }}
                                    >
                                      <div
                                        className="w_subsearch_res_text"
                                        role="button"
                                        data-container="body"
                                      >
                                        <button
                                          onClick={(e) => {
                                            this.handleOpenFullEventClick(
                                              e,
                                              row.evid
                                            );
                                          }}
                                          type="button"
                                          style={{ padding: "1px 6px" }}
                                          className="btn btn-default btn-xs w_p_action_sub"
                                          title={this.props.translate(
                                            "View content"
                                          )}
                                        >
                                          <span
                                            className="fa fa-folder-open"
                                            aria-hidden="true"
                                          />
                                        </button>
                                      </div>
                                    </div>
                                    <div
                                      className="td"
                                      style={{ flexGrow: "0.5" }}
                                    >
                                      <div
                                        className="w_subsearch_res_text"
                                        role="button"
                                        data-container="body"
                                      >
                                        {row.ownId && (
                                          <button
                                            type="button"
                                            onClick={(e) => {
                                              this.handleGetDocsBucketWithBatchClick(
                                                e,
                                                row.ownId
                                              );
                                            }}
                                            style={{ padding: "1px 6px" }}
                                            className="btn btn-default btn-xs w_p_action_sub"
                                            title={this.props.translate(
                                              "View content"
                                            )}
                                          >
                                            <span
                                              className="fa fa-folder-open"
                                              aria-hidden="true"
                                            />
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                    <div
                                      className="td"
                                      style={{ flexGrow: "0.5" }}
                                    >
                                      <div
                                        className="w_subsearch_res_text"
                                        role="button"
                                        data-container="body"
                                      >
                                        {row.batch && (
                                          <button
                                            type="button"
                                            onClick={(e) => {
                                              this.handleGetDocsBucketWithBatchClick(
                                                e,
                                                row.batch
                                              );
                                            }}
                                            style={{ padding: "1px 6px" }}
                                            className="btn btn-default btn-xs w_p_action_sub"
                                            title={this.props.translate(
                                              "View content"
                                            )}
                                          >
                                            <span
                                              className="fa fa-folder-open"
                                              aria-hidden="true"
                                            />
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            {this.state.fileListResult.length === 0 && (
                              <div className="tr">
                                <div
                                  className="td justify-content-center"
                                  style={{ flexGrow: "2" }}
                                >
                                  <span>
                                    {this.props.translate("NoResults")}
                                  </span>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                    {this.state.fileListResult &&
                      this.state.fileListResult.length > 0 && (
                        <Pagination className="justify-content-center">
                          <PaginationItem>
                            {prevFile === 0 ? (
                              <PaginationLink disabled>
                                <small>
                                  <span className="fa fa-fast-backward" />
                                </small>
                                &nbsp;{this.props.translate("First")}
                              </PaginationLink>
                            ) : (
                              <PaginationLink
                                onClick={this.handleFileFirstClick.bind(this)}
                                id={prevFile}
                                href={prevFile}
                              >
                                <small>
                                  <span className="fa fa-fast-backward" />
                                </small>
                                &nbsp;{this.props.translate("First")}
                              </PaginationLink>
                            )}
                          </PaginationItem>
                          <PaginationItem>
                            {prevFile === 0 ? (
                              <PaginationLink disabled>
                                <small>
                                  <span className="fa fa-backward" />
                                </small>
                                &nbsp;{this.props.translate("Prev")}
                              </PaginationLink>
                            ) : (
                              <PaginationLink
                                onClick={this.handleFilePageClick.bind(this)}
                                id={prevFile}
                                href={prevFile}
                              >
                                <small>
                                  <span className="fa fa-backward" />
                                </small>
                                &nbsp;{this.props.translate("Prev")}
                              </PaginationLink>
                            )}
                          </PaginationItem>
                          {pageNumbersFile.map((number, i) => (
                            <Pagination key={i}>
                              <PaginationItem
                                active={
                                  pageNumbersFile.indexOf(filePageNumber) === i
                                    ? true
                                    : false
                                }
                              >
                                <PaginationLink
                                  onClick={this.handleFilePageClick.bind(this)}
                                  href={number}
                                  key={number}
                                  id={number}
                                >
                                  {number}
                                </PaginationLink>
                              </PaginationItem>
                            </Pagination>
                          ))}

                          <PaginationItem>
                            {filePageNumber >= lastFile ? (
                              <PaginationLink disabled>
                                {this.props.translate("Next")}&nbsp;
                                <small>
                                  <span className="fa fa-forward" />
                                </small>
                              </PaginationLink>
                            ) : (
                              <PaginationLink
                                onClick={this.handleFilePageClick.bind(this)}
                                id={
                                  pageNumbersFile[
                                    pageNumbersFile.indexOf(filePageNumber) + 1
                                  ]
                                }
                                href={
                                  pageNumbersFile[
                                    pageNumbersFile.indexOf(filePageNumber) + 1
                                  ]
                                }
                              >
                                {this.props.translate("Next")}&nbsp;
                                <small>
                                  <span className="fa fa-forward" />
                                </small>
                              </PaginationLink>
                            )}
                          </PaginationItem>
                        </Pagination>
                      )}
                  </div>
                </div>
              </TabPane>
              <TabPane className="h-100" tabId="2">
                <div className="d-flex" style={{ height: "inherit" }}>
                  <div className="d-flex flex-column w-100 flowCustom6">
                    <div className="">
                      <div className="d-flex flex-column justify-content-center">
                        <div className="w-100 p-1">
                          <div
                            className="flex-column"
                            id="events_grids1"
                            style={{ marginBottom: "2px", fontSize: ".7rem" }}
                          >
                            <div
                              className="d-flex w-100 w_subsearch_res_body_row"
                              style={{
                                background: "#F5F5F5",
                                padding: "10px 5px 5px 5px",
                              }}
                            >
                              <div
                                className="col-3 d-inline w_subsearch_res_text bold"
                                translate="Platform"
                              >
                                {this.props.translate("Platform")}
                              </div>
                              <div
                                className="col-3 d-inline w_subsearch_res_text "
                                id="events_grids1_platform"
                              >
                                {eventId.platform}
                              </div>
                              <div
                                className="col-3 d-inline w_subsearch_res_text bold"
                                translate="Start"
                              >
                                {this.props.translate("Start")}
                              </div>
                              <div
                                className="col-3 d-inline w_subsearch_res_text"
                                id="events_grids1_start"
                              >
                                {startEvent}
                              </div>
                            </div>
                            <div
                              className="d-flex w-100 w_subsearch_res_body_row"
                              style={{
                                background: "#F5F5F5",
                                padding: "0 5px 5px 5px",
                              }}
                            >
                              <div
                                className="col-3 d-inline w_subsearch_res_text bold"
                                translate="Service"
                              >
                                {this.props.translate("Service")}
                              </div>
                              <div
                                className="col-3 d-inline w_subsearch_res_text"
                                id="events_grids1_service"
                              >
                                {eventId.service}
                              </div>
                              <div
                                className="col-3 d-inline w_subsearch_res_text bold"
                                translate="End"
                              >
                                {this.props.translate("End")}
                              </div>
                              <div
                                className="col-3 d-inline w_subsearch_res_text"
                                id="events_grids1_end"
                              >
                                {endEvent}
                              </div>
                            </div>
                            <div
                              className="d-flex w-100 w_subsearch_res_body_row"
                              style={{
                                background: "#F5F5F5",
                                padding: "0 5px 10px 5px",
                              }}
                            >
                              <div
                                className="col-3 d-inline w_subsearch_res_text bold"
                                translate="Host"
                              >
                                {this.props.translate("Host")}
                              </div>
                              <div
                                className="col-3 d-inline w_subsearch_res_text"
                                id="events_grids1_host"
                              >
                                {eventHost}
                              </div>
                              <div
                                className="col-3 d-inline w_subsearch_res_text bold"
                                translate="ProductionMode"
                              >
                                {this.props.translate("ProductionMode")}
                              </div>
                              <div
                                className="col-3 d-inline w_subsearch_res_text"
                                id="events_grids1_mode"
                              >
                                {eventMode}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="w-100">
                          <div className="w-100">
                            <ButtonGroup className="w-100">
                              <Button
                                active={
                                  this.state.eventParams.Status === ""
                                    ? true
                                    : false
                                }
                                onClick={() => {
                                  this.toggleEventStatus("");
                                }}
                                className="w-100"
                              >
                                {this.props.translate("All")}
                                <span className="w_eventsCount_sub_all">
                                  (
                                  {this.state.eventsCounts.ok +
                                    this.state.eventsCounts.warning +
                                    this.state.eventsCounts.error}
                                  )
                                </span>
                              </Button>
                              <Button
                                active={
                                  this.state.eventParams.Status === "ok"
                                    ? true
                                    : false
                                }
                                onClick={() => {
                                  this.toggleEventStatus("ok");
                                }}
                                className="w-100"
                              >
                                {this.props.translate("OK")}
                                <span className="w_eventsCount_sub_ok">
                                  ({this.state.eventsCounts.ok})
                                </span>
                              </Button>
                              <Button
                                active={
                                  this.state.eventParams.Status === "warning"
                                    ? true
                                    : false
                                }
                                onClick={() => {
                                  this.toggleEventStatus("warning");
                                }}
                                className="w-100"
                              >
                                {this.props.translate("Warning")}
                                <span className="w_eventsCount_sub_warning">
                                  ({this.state.eventsCounts.warning})
                                </span>
                              </Button>
                              <Button
                                active={
                                  this.state.eventParams.Status === "error"
                                    ? true
                                    : false
                                }
                                onClick={() => {
                                  this.toggleEventStatus("error");
                                }}
                                className="w-100"
                              >
                                {this.props.translate("Errors")}
                                <span className="w_eventsCount_sub_error">
                                  ({this.state.eventsCounts.error})
                                </span>
                              </Button>
                            </ButtonGroup>
                          </div>
                          <div
                            className="w-100 d-flex flex-column"
                            style={{ marginTop: ".5rem" }}
                          >
                            <div className="form-group flowCustom3">
                              <label
                                htmlFor="searchFileName"
                                className="sr-only"
                              >
                                <span translate="EventID">
                                  {this.props.translate("EventID")}
                                </span>
                              </label>
                              <span className="event-search-control w-100">
                                <Input
                                  type="text"
                                  value={this.state.eventParams.EventId}
                                  onChange={this.onEventsEventIDChange.bind(
                                    this
                                  )}
                                  name="EventId"
                                  placeholder={this.props.translate("EventID")}
                                />
                              </span>
                            </div>
                          </div>
                          <div className="flowCustom4">
                            <div className="btn-group eventSearchSubmit col-12">
                              <button
                                id="eventSearchSubmit"
                                type="submit"
                                onClick={this.onEventSearchClick.bind(this)}
                                data-type="events"
                                className="btn btn-secondary btn-sm w_flow_subsearch"
                                style={{
                                  margin: "0.2em 0 1.2em 0em",
                                  backgroundColor: "rgb(230, 230, 230)",
                                }}
                              >
                                <span className="fa fa-search" />{" "}
                                <span style={{ marginLeft: "5px" }}>
                                  {this.props.translate("Search")}
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-100 h-100 border rounded flowCustom5">
                      <div
                        className="table w_subsearch_res_body"
                        id="events_grids2"
                      >
                        <div className="tr th">
                          <div className="td" style={{ flexGrow: "3" }}>
                            {this.props.translate("EventID")}
                          </div>
                          <div className="td" style={{ flexGrow: "1" }}>
                            {this.props.translate("Channel")}
                          </div>
                          <div className="td" style={{ flexGrow: "1" }}>
                            {this.props.translate("Status")}
                          </div>
                          {this.showExternalUrlColumn(
                            this.state.eventListResult
                          ) && <div className="td">URL</div>}
                          <div className="td" style={{ flexGrow: "1" }}>
                            &nbsp;
                          </div>
                        </div>
                        {this.state.eventListLoading ? (
                          <div className="tr">
                            <div
                              className="td justify-content-center"
                              style={{ flexGrow: "2" }}
                            >
                              <Spinner color="info" size="sm" />
                            </div>
                          </div>
                        ) : (
                          <>
                            {this.state.eventListResult &&
                              this.state.eventListResult.length > 0 &&
                              this.state.eventListResult.map((row, i) => {
                                return (
                                  <div key={i} className="tr">
                                    <div
                                      className="td"
                                      style={{ flexGrow: "3" }}
                                    >
                                      <div className="w_subsearch_res_text">
                                        {/* <CopyToClipboard text={row.evhid}>
                                          <button
                                            type="button"
                                            className="btn btn-default btn-xs btn-copy js-copy"
                                            style={{
                                              padding: "1px 2px",
                                              lineHeight: "0.8",
                                            }}
                                            data-container="body"
                                            title={this.props.translate(
                                              "Copy to clipboard"
                                            )}
                                          >
                                            <svg
                                              className="icon"
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                            >
                                              <path d="M17,9H7V7H17M17,13H7V11H17M14,17H7V15H14M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z" />
                                            </svg>
                                          </button>
                                        </CopyToClipboard> */}
                                        <span style={{ marginLeft: "4px" }}>
                                          {row.evhid}
                                        </span>
                                      </div>
                                    </div>
                                    <div
                                      className="td"
                                      style={{ flexGrow: "1" }}
                                    >
                                      <div className="w_subsearch_res_text">
                                        {/* <CopyToClipboard text={row.ch}>
                                          <button
                                            type="button"
                                            className="btn btn-default btn-xs btn-copy js-copy"
                                            style={{
                                              padding: "1px 2px",
                                              lineHeight: "0.8",
                                            }}
                                            data-container="body"
                                            title={this.props.translate(
                                              "Copy to clipboard"
                                            )}
                                          >
                                            <svg
                                              className="icon"
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                            >
                                              <path d="M17,9H7V7H17M17,13H7V11H17M14,17H7V15H14M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z" />
                                            </svg>
                                          </button>
                                        </CopyToClipboard> */}
                                        <span style={{ marginLeft: "4px" }}>
                                          {row.ch}
                                        </span>
                                      </div>
                                    </div>
                                    <div
                                      className="td"
                                      style={{ flexGrow: "1" }}
                                    >
                                      <div
                                        className="w_subsearch_res_text"
                                        data-container="body"
                                      >
                                        {row.link && row.link.length > 0 ? (
                                          <a
                                            href={row.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            <b>{row.st}</b>
                                          </a>
                                        ) : (
                                          row.st
                                        )}
                                      </div>
                                    </div>
                                    {this.showExternalUrlColumn(
                                      this.state.eventListResult
                                    ) && (
                                      <div
                                        className="td"
                                        style={{ flexGrow: "0.6" }}
                                      >
                                        <div
                                          className="w_subsearch_res_text"
                                          role="button"
                                          data-container="body"
                                        >
                                          {row.externalLink &&
                                            row.externalLink.link && (
                                              <button
                                                onClick={(e) => {
                                                  window.open(
                                                    row.externalLink.link,
                                                    "_blank"
                                                  );
                                                }}
                                                type="button"
                                                style={{ padding: "1px 6px" }}
                                                className="btn btn-default btn-xs w_p_action_sub"
                                                title={
                                                  row.externalLink.description
                                                }
                                              >
                                                <span
                                                  className="fa fa-external-link-alt"
                                                  aria-hidden="true"
                                                />
                                              </button>
                                            )}
                                        </div>
                                      </div>
                                    )}
                                    <div
                                      className="td"
                                      style={{ flexGrow: "1" }}
                                    >
                                      <div
                                        className="w_subsearch_res_text"
                                        role="button"
                                        data-container="body"
                                      >
                                        <button
                                          type="button"
                                          onClick={(e) => {
                                            this.handleOpenFullEventClick(
                                              e,
                                              row.evid
                                            );
                                          }}
                                          style={{ padding: "1px 6px" }}
                                          className="btn btn-default btn-xs w_p_action_sub"
                                          title={this.props.translate(
                                            "View content"
                                          )}
                                        >
                                          <span
                                            className="fa fa-folder-open"
                                            aria-hidden="true"
                                          />
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            {this.state.eventListResult.length === 0 && (
                              <div className="tr">
                                <div
                                  className="td justify-content-center"
                                  style={{ flexGrow: "2" }}
                                >
                                  <span>
                                    {this.props.translate("NoResults")}
                                  </span>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                    {this.state.eventListResult &&
                      this.state.eventListResult.length > 0 && (
                        <Pagination className="justify-content-center">
                          <PaginationItem>
                            {prevEvent === 0 ? (
                              <PaginationLink disabled>
                                <small>
                                  <span className="fa fa-fast-backward" />
                                </small>
                                &nbsp;{this.props.translate("First")}
                              </PaginationLink>
                            ) : (
                              <PaginationLink
                                onClick={this.handleEventFirstClick.bind(this)}
                                id={prevEvent}
                                href={prevEvent}
                              >
                                <small>
                                  <span className="fa fa-fast-backward" />
                                </small>
                                &nbsp;{this.props.translate("First")}
                              </PaginationLink>
                            )}
                          </PaginationItem>
                          <PaginationItem>
                            {prevEvent === 0 ? (
                              <PaginationLink disabled>
                                <small>
                                  <span className="fa fa-backward" />
                                </small>
                                &nbsp;{this.props.translate("Prev")}
                              </PaginationLink>
                            ) : (
                              <PaginationLink
                                onClick={this.handleEventPageClick.bind(this)}
                                id={prevEvent}
                                href={prevEvent}
                              >
                                <small>
                                  <span className="fa fa-backward" />
                                </small>
                                &nbsp;{this.props.translate("Prev")}
                              </PaginationLink>
                            )}
                          </PaginationItem>
                          {pageNumbersEvent.map((number, i) => (
                            <Pagination key={i}>
                              <PaginationItem
                                active={
                                  pageNumbersEvent.indexOf(eventPageNumber) ===
                                  i
                                    ? true
                                    : false
                                }
                              >
                                <PaginationLink
                                  onClick={this.handleEventPageClick.bind(this)}
                                  href={number}
                                  key={number}
                                  id={number}
                                >
                                  {number}
                                </PaginationLink>
                              </PaginationItem>
                            </Pagination>
                          ))}

                          <PaginationItem>
                            {eventPageNumber >= lastEvent ? (
                              <PaginationLink disabled>
                                {this.props.translate("Next")}&nbsp;
                                <small>
                                  <span className="fa fa-forward" />
                                </small>
                              </PaginationLink>
                            ) : (
                              <PaginationLink
                                onClick={this.handleEventPageClick.bind(this)}
                                id={
                                  pageNumbersEvent[
                                    pageNumbersEvent.indexOf(eventPageNumber) +
                                      1
                                  ]
                                }
                                href={
                                  pageNumbersEvent[
                                    pageNumbersEvent.indexOf(eventPageNumber) +
                                      1
                                  ]
                                }
                              >
                                {this.props.translate("Next")}&nbsp;
                                <small>
                                  <span className="fa fa-forward" />
                                </small>
                              </PaginationLink>
                            )}
                          </PaginationItem>
                        </Pagination>
                      )}
                  </div>
                </div>
              </TabPane>
              <TabPane className="h-100" tabId="3">
                <div className="d-flex" style={{ height: "inherit" }}>
                  <div className="d-flex flex-column w-100 flowCustom6">
                    <div className="">
                      <div className="d-flex flex-column flex-xl-row justify-content-center">
                        <div className="w-100">
                          <div className="w-100">
                            <ButtonGroup className="w-100">
                              <Button
                                active={
                                  this.state.docParams.Status === ""
                                    ? true
                                    : false
                                }
                                onClick={() => {
                                  this.toggleDocStatus("");
                                }}
                                className="w-100"
                              >
                                {this.props.translate("All")}
                                <span className="w_documentsCount_sub_all">
                                  (
                                  {this.state.docsCounts.ok +
                                    this.state.docsCounts.warning +
                                    this.state.docsCounts.error}
                                  )
                                </span>
                              </Button>
                              <Button
                                active={
                                  this.state.docParams.Status === "ok"
                                    ? true
                                    : false
                                }
                                onClick={() => {
                                  this.toggleDocStatus("ok");
                                }}
                                className="w-100"
                              >
                                {this.props.translate("OK")}
                                <span className="w_documentsCount_sub_ok">
                                  ({this.state.docsCounts.ok})
                                </span>
                              </Button>
                              <Button
                                active={
                                  this.state.docParams.Status === "warning"
                                    ? true
                                    : false
                                }
                                onClick={() => {
                                  this.toggleDocStatus("warning");
                                }}
                                className="w-100"
                              >
                                {this.props.translate("Warning")}
                                <span className="w_documentsCount_sub_warning">
                                  ({this.state.docsCounts.warning})
                                </span>
                              </Button>
                              <Button
                                active={
                                  this.state.docParams.Status === "error"
                                    ? true
                                    : false
                                }
                                onClick={() => {
                                  this.toggleDocStatus("error");
                                }}
                                className="w-100"
                              >
                                {this.props.translate("Errors")}
                                <span className="w_documentsCount_sub_error">
                                  ({this.state.docsCounts.error})
                                </span>
                              </Button>
                            </ButtonGroup>
                          </div>
                          <div
                            className="w-100 d-flex flex-column"
                            style={{ marginTop: ".5rem" }}
                          >
                            <div
                              className="form-group flowCustom3"
                              style={{ marginBottom: "0.5em" }}
                            >
                              <label
                                htmlFor="searchFileName"
                                className="sr-only"
                              >
                                <span translate="EventID">
                                  {this.props.translate("EventID")}
                                </span>
                              </label>
                              <span className="event-search-control w-100">
                                <Input
                                  type="text"
                                  value={this.state.docParams.EventId}
                                  onChange={this.onDocsEventIDChange.bind(this)}
                                  name="EventId"
                                  placeholder={this.props.translate("EventID")}
                                />
                              </span>
                            </div>
                            <div
                              className="form-group flowCustom3"
                              style={{ marginBottom: "0.5em" }}
                            >
                              <label
                                htmlFor="searchFileName"
                                className="sr-only"
                              >
                                <span>
                                  {this.props.translate("DocumentNumber")}
                                </span>
                              </label>
                              <span className="event-search-control w-100">
                                <Input
                                  type="text"
                                  value={this.state.docParams.DocNr}
                                  onChange={this.onDocsDocNrChange.bind(this)}
                                  name="DocNr"
                                  placeholder={`${this.props.translate(
                                    "DocumentNumber"
                                  )} (Use * to do 'starts with' search)`}
                                />
                              </span>
                            </div>
                            <div
                              className="form-group flowCustom3"
                              style={{ marginBottom: "0.5em" }}
                            >
                              <label
                                htmlFor="searchFileName"
                                className="sr-only"
                              >
                                <span translate="DocumentId">
                                  {this.props.translate("DocumentId")}
                                </span>
                              </label>
                              <span className="event-search-control w-100">
                                <Input
                                  type="text"
                                  value={this.state.docParams.DocId}
                                  onChange={this.onDocsDocIdChange.bind(this)}
                                  name="DocId"
                                  placeholder={`${this.props.translate(
                                    "DocumentId"
                                  )} (Use * to do 'starts with' search)`}
                                />
                              </span>
                            </div>
                            <div
                              className="form-group flowCustom3"
                              style={{ marginBottom: "0.5em" }}
                            >
                              <label
                                htmlFor="searchFileName"
                                className="sr-only"
                              >
                                <span translate="BatchId">
                                  {this.props.translate("BatchId")}
                                </span>
                              </label>
                              <span className="event-search-control w-100">
                                <Input
                                  type="text"
                                  value={this.state.docParams.batch}
                                  onChange={this.onDocsBatchIdChange.bind(this)}
                                  name="BatchId"
                                  placeholder={`${this.props.translate(
                                    "BatchId"
                                  )} (Use * to do 'starts with' search)`}
                                />
                              </span>
                            </div>
                            <div
                              className="form-group flowCustom3"
                              style={{ marginBottom: "0.5em" }}
                            >
                              <label
                                htmlFor="searchFileName"
                                className="sr-only"
                              >
                                <span>{this.props.translate("Channel")}</span>
                              </label>
                              <span className="event-search-control w-100">
                                <Input
                                  type="text"
                                  value={this.state.docParams.channel}
                                  onChange={this.onDocsChannelChange.bind(this)}
                                  name="Channel"
                                  placeholder={`${this.props.translate(
                                    "Channel"
                                  )} (Use * to do 'starts with' search)`}
                                />
                              </span>
                            </div>
                            <div
                              className="form-group flowCustom3"
                              style={{
                                marginLeft: "1.5em",
                                marginBottom: "0.5em",
                              }}
                            >
                              <Input
                                type="checkbox"
                                id="OnlyFromThisFile"
                                value={
                                  !!this.state.docParams &&
                                  !!this.state.docParams.isRelated
                                }
                                onChange={this.onOnlyFromThisFileCheckboxChange}
                              />
                              <Label htmlFor="OnlyFromThisFile">
                                {this.props.translate("Only from this file")}
                              </Label>
                            </div>
                          </div>
                          <div className="flowCustom4">
                            <div className="btn-group eventSearchSubmit col-12">
                              <button
                                type="submit"
                                onClick={this.onDocSearchClick.bind(this)}
                                className="btn btn-secondary btn-sm w_flow_subsearch"
                                style={{
                                  margin: "0.2em 0 1.2em 0em",
                                  backgroundColor: "rgb(230, 230, 230)",
                                }}
                              >
                                <span className="fa fa-search" />{" "}
                                <span>{this.props.translate("Search")}</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-100 h-100 border rounded flowCustom5">
                      <div
                        className="table w_subsearch_res_body"
                        id="documents_grids1"
                      >
                        <div className="tr th">
                          <div className="td" style={{ flexGrow: "2" }}>
                            {this.props.translate("DocumentNumber")}
                          </div>
                          <div className="td" style={{ flexGrow: "1" }}>
                            {this.props.translate("Channel")}
                          </div>
                          <div className="td" style={{ flexGrow: "2" }}>
                            {this.props.translate("DocumentId")}
                          </div>
                          <div className="td" style={{ flexGrow: "1" }}>
                            {this.props.translate("Status")}
                          </div>
                          {this.showExternalUrlColumn(
                            this.state.docListResult
                          ) && (
                            <div style={{ flexGrow: "0.5" }} className="td">
                              URL
                            </div>
                          )}
                          <div className="td" style={{ flexGrow: "0.5" }}>
                            JSON
                          </div>
                          <div className="td" style={{ flexGrow: "0.5" }}>
                            DOB
                          </div>
                          <div className="td" style={{ flexGrow: "0.5" }}>
                            {this.props.translate("Parked")}
                          </div>
                          <div className="td" style={{ flexGrow: "0.5" }}>
                            {this.props.translate("Batch")}
                          </div>
                        </div>
                        {this.state.docListLoading ? (
                          <div className="tr">
                            <div
                              className="td justify-content-center"
                              style={{ flexGrow: "2" }}
                            >
                              <Spinner color="info" size="sm" />
                            </div>
                          </div>
                        ) : (
                          <>
                            {this.state.docListResult &&
                              this.state.docListResult.length > 0 &&
                              this.state.docListResult.map((row, i) => {
                                return (
                                  <div key={i} className="tr">
                                    <div
                                      className="td"
                                      style={{ flexGrow: "2" }}
                                    >
                                      <div
                                        className="w_subsearch_res_text"
                                        style={{ display: "flex" }}
                                      >
                                        {/* <CopyToClipboard text={row.docnr}>
                                      <button
                                        type="button"
                                        className="btn btn-default btn-xs btn-copy js-copy"
                                        style={{
                                          padding: "1px 2px",
                                          lineHeight: "0.8",
                                        }}
                                        data-container="body"
                                        title={this.props.translate(
                                          "Copy to clipboard"
                                        )}
                                      >
                                        <svg
                                          className="icon"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                        >
                                          <path d="M17,9H7V7H17M17,13H7V11H17M14,17H7V15H14M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z" />
                                        </svg>
                                      </button>
                                    </CopyToClipboard> */}
                                        <div
                                          style={{
                                            marginLeft: "4px",
                                            whiteSpace: "initial",
                                          }}
                                        >
                                          {row.docnr}
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="td"
                                      style={{ flexGrow: "1" }}
                                    >
                                      <div className="w_subsearch_res_text">
                                        {/* <CopyToClipboard text={row.ch}>
                                      <button
                                        type="button"
                                        className="btn btn-default btn-xs btn-copy js-copy"
                                        style={{
                                          padding: "1px 2px",
                                          lineHeight: "0.8",
                                        }}
                                        data-container="body"
                                        title={this.props.translate(
                                          "Copy to clipboard"
                                        )}
                                      >
                                        <svg
                                          className="icon"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                        >
                                          <path d="M17,9H7V7H17M17,13H7V11H17M14,17H7V15H14M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z" />
                                        </svg>
                                      </button>
                                    </CopyToClipboard> */}
                                        <span style={{ marginLeft: "4px" }}>
                                          {row.ch}
                                          {row.chop && ` (${row.chop})`}
                                        </span>
                                      </div>
                                    </div>
                                    <div
                                      className="td"
                                      style={{ flexGrow: "2" }}
                                    >
                                      <div
                                        className="w_subsearch_res_text"
                                        style={{ whiteSpace: "initial" }}
                                      >
                                        {row.docid}
                                      </div>
                                    </div>
                                    <div
                                      className="td"
                                      style={{ flexGrow: "1" }}
                                    >
                                      <div
                                        className="w_subsearch_res_text"
                                        data-container="body"
                                      >
                                        {row.link && row.link.length > 0 ? (
                                          <a
                                            href={row.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            <b>{row.st}</b>
                                          </a>
                                        ) : (
                                          row.st
                                        )}
                                      </div>
                                    </div>
                                    {this.showExternalUrlColumn(
                                      this.state.docListResult
                                    ) && (
                                      <div
                                        className="td"
                                        style={{ flexGrow: "0.5" }}
                                      >
                                        <div
                                          className="w_subsearch_res_text"
                                          role="button"
                                          data-container="body"
                                        >
                                          {row.externalLink &&
                                            row.externalLink.link && (
                                              <button
                                                onClick={(e) => {
                                                  window.open(
                                                    row.externalLink.link,
                                                    "_blank"
                                                  );
                                                }}
                                                type="button"
                                                style={{ padding: "1px 6px" }}
                                                className="btn btn-default btn-xs w_p_action_sub"
                                                title={
                                                  row.externalLink.description
                                                }
                                              >
                                                <span
                                                  className="fa fa-external-link-alt"
                                                  aria-hidden="true"
                                                />
                                              </button>
                                            )}
                                        </div>
                                      </div>
                                    )}
                                    <div
                                      className="td"
                                      style={{ flexGrow: "0.5" }}
                                    >
                                      <div
                                        className="w_subsearch_res_text"
                                        role="button"
                                        data-container="body"
                                      >
                                        <button
                                          type="button"
                                          onClick={(e) => {
                                            this.handleOpenFullEventClick(
                                              e,
                                              row.evid
                                            );
                                          }}
                                          style={{ padding: "1px 6px" }}
                                          className="btn btn-default btn-xs w_p_action_sub"
                                          title={this.props.translate(
                                            "View content"
                                          )}
                                        >
                                          <span
                                            className="fa fa-folder-open"
                                            aria-hidden="true"
                                          />
                                        </button>
                                      </div>
                                    </div>
                                    <div
                                      className="td"
                                      style={{ flexGrow: "0.5" }}
                                    >
                                      <div
                                        className="w_subsearch_res_text"
                                        role="button"
                                        data-container="body"
                                      >
                                        {row.docid && (
                                          <button
                                            type="button"
                                            onClick={(e) => {
                                              this.handleGetDocsBucketClick(
                                                e,
                                                row.docid
                                              );
                                            }}
                                            style={{ padding: "1px 6px" }}
                                            className="btn btn-default btn-xs w_p_action_sub"
                                            title={this.props.translate(
                                              "View content"
                                            )}
                                          >
                                            <span
                                              className="fa fa-folder-open"
                                              aria-hidden="true"
                                            />
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                    <div
                                      className="td"
                                      style={{ flexGrow: "0.5" }}
                                    >
                                      <div
                                        className="w_subsearch_res_text"
                                        role="button"
                                        data-container="body"
                                      >
                                        {row.docid && (
                                          <button
                                            type="button"
                                            onClick={(e) => {
                                              this.handleGetParkedClick(
                                                e,
                                                row.docid
                                              );
                                            }}
                                            style={{ padding: "1px 6px" }}
                                            className="btn btn-default btn-xs w_p_action_sub"
                                            title={this.props.translate(
                                              "View content"
                                            )}
                                          >
                                            <span
                                              className="fa fa-folder-open"
                                              aria-hidden="true"
                                            />
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                    <div
                                      className="td"
                                      style={{ flexGrow: "0.5" }}
                                    >
                                      <div
                                        className="w_subsearch_res_text"
                                        role="button"
                                        data-container="body"
                                      >
                                        {row.batch && (
                                          <button
                                            type="button"
                                            onClick={(e) => {
                                              this.handleGetDocsBucketWithBatchClick(
                                                e,
                                                row.batch
                                              );
                                            }}
                                            style={{ padding: "1px 6px" }}
                                            className="btn btn-default btn-xs w_p_action_sub"
                                            title={this.props.translate(
                                              "View content"
                                            )}
                                          >
                                            <span
                                              className="fa fa-folder-open"
                                              aria-hidden="true"
                                            />
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            {this.state.docListResult.length === 0 && (
                              <div className="tr">
                                <div
                                  className="td justify-content-center"
                                  style={{ flexGrow: "2" }}
                                >
                                  <span>
                                    {this.props.translate("NoResults")}
                                  </span>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                    {this.state.docListResult &&
                      this.state.docListResult.length > 0 && (
                        <Pagination className="justify-content-center">
                          <PaginationItem>
                            {prevDoc === 0 ? (
                              <PaginationLink disabled>
                                <small>
                                  <span className="fa fa-fast-backward" />
                                </small>
                                &nbsp;{this.props.translate("First")}
                              </PaginationLink>
                            ) : (
                              <PaginationLink
                                onClick={this.handleDocFirstClick.bind(this)}
                                id={prevDoc}
                                href={prevDoc}
                              >
                                <small>
                                  <span className="fa fa-fast-backward" />
                                </small>
                                &nbsp;{this.props.translate("First")}
                              </PaginationLink>
                            )}
                          </PaginationItem>
                          <PaginationItem>
                            {prevDoc === 0 ? (
                              <PaginationLink disabled>
                                <small>
                                  <span className="fa fa-backward" />
                                </small>
                                &nbsp;{this.props.translate("Prev")}
                              </PaginationLink>
                            ) : (
                              <PaginationLink
                                onClick={(e) =>
                                  this.handleDocPageClick(e, prevDoc)
                                }
                                id={prevDoc}
                                href={prevDoc}
                              >
                                <small>
                                  <span className="fa fa-backward" />
                                </small>
                                &nbsp;{this.props.translate("Prev")}
                              </PaginationLink>
                            )}
                          </PaginationItem>
                          {pageNumbersDoc.map((number, i) => (
                            <Pagination key={i}>
                              <PaginationItem
                                active={
                                  pageNumbersDoc.indexOf(docPageNumber) === i
                                    ? true
                                    : false
                                }
                              >
                                <PaginationLink
                                  onClick={(e) =>
                                    this.handleDocPageClick(e, number)
                                  }
                                  href={number}
                                  key={number}
                                  id={number}
                                >
                                  {number}
                                </PaginationLink>
                              </PaginationItem>
                            </Pagination>
                          ))}

                          <PaginationItem>
                            {docPageNumber >= lastDoc ? (
                              <PaginationLink disabled>
                                {this.props.translate("Next")}&nbsp;
                                <small>
                                  <span className="fa fa-forward" />
                                </small>
                              </PaginationLink>
                            ) : (
                              <PaginationLink
                                onClick={(e) =>
                                  this.handleDocPageClick(e, docPageNumber + 1)
                                }
                                id={
                                  pageNumbersDoc[
                                    pageNumbersDoc.indexOf(docPageNumber) + 1
                                  ]
                                }
                                href={
                                  pageNumbersDoc[
                                    pageNumbersDoc.indexOf(docPageNumber) + 1
                                  ]
                                }
                              >
                                {this.props.translate("Next")}&nbsp;
                                <small>
                                  <span className="fa fa-forward" />
                                </small>
                              </PaginationLink>
                            )}
                          </PaginationItem>
                        </Pagination>
                      )}
                  </div>
                </div>
              </TabPane>
            </TabContent>
          </div>
        </SplitterLayout>
        <Modal
          style={{ width: "70vw", maxWidth: "95vw" }}
          isOpen={this.state.fullEventModal}
          toggle={this.toggleFullEventModal}
        >
          <ModalHeader toggle={this.toggleFullEventModal}>Details</ModalHeader>
          <ModalBody>
            <ReactJson src={this.state.eventJsonObj} displayDataTypes={false} />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { flows, authentication, locale, config } = state;
  const { user } = authentication;
  return {
    user,
    flows,
    platformNames: config.platformNames,
    translate: getTranslate(locale),
  };
}

const connectedFiles = connect(mapStateToProps)(withRouter(Flows));
export { connectedFiles as Flows };
